<div class="form-title">
  <div class="form-title-text">
    {{ inputInvoice.company.regularName }}
  </div>
</div>

<mat-form-field appearance="outline">
  <input
    matInput
    placeholder="Referentienummer"
    [(ngModel)]="inputInvoice.referenceNumber"
    name="referenceNumberInput"
    (ngModelChange)="referenceNumberChanged()"
  />
</mat-form-field>

<div *ngFor="let product of project.products; let index = index">
  <div *ngIf="product.id != null">
    <div class="product-title">
      {{
        (product.type | productType: product.otherProductName) +
          ' #' +
          (index + 1)
      }}
    </div>
    <div *ngIf="isWindowSticker(product) || isCustomWindowSticker(product)">
      <div
        *ngIf="isWindowSticker(product) && invoiceType === 'PlacementInvoice'"
      >
        <div *ngIf="product.standardStickerParts?.length <= 1">
          <div class="title">
            Standaardprijzen
          </div>
          <div class="d-flex">
            <div class="first-form-field">
              <div class="price-label">
                Productieprijs{{
                  involvedCompanies?.length > 1
                    ? ' / ' + involvedCompanies?.length
                    : ''
                }}
              </div>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  [disabled]="true"
                  [value]="
                    '€ ' +
                    (product.standardStickerParts[0]?.productSize
                      ?.productionPrice
                      | multiply: companyFactor
                      | asFormatDecimal: true:2)
                  "
                />
              </mat-form-field>
            </div>

            <div class="form-field-no-flex">
              <div class="price-label">
                Plaatsingsprijs{{
                  involvedCompanies?.length > 1
                    ? ' / ' + involvedCompanies?.length
                    : ''
                }}
              </div>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  [disabled]="true"
                  [value]="
                    '€ ' +
                    (product.standardStickerParts[0]?.productSize
                      ?.placementPrice
                      | multiply: companyFactor
                      | asFormatDecimal: true:2)
                  "
                />
              </mat-form-field>
            </div>

            <div>
              <div class="price-label">
                Som{{
                  involvedCompanies?.length > 1
                    ? ' / ' + involvedCompanies?.length
                    : ''
                }}
              </div>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  [disabled]="true"
                  [value]="
                    '€ ' +
                    (product.standardStickerParts[0]?.productSize
                      ?.productionPrice
                      | sum
                        : product.standardStickerParts[0]?.productSize
                            ?.placementPrice
                      | multiply: companyFactor
                      | asFormatDecimal: true:2)
                  "
                />
              </mat-form-field>
            </div>
          </div>
        </div>
        <mat-checkbox
          [checked]="productToUsePlacementLine.get(product.id)"
          [disabled]="product.standardStickerParts?.length > 1"
          (change)="usePlacementLineChanged($event, product.id)"
          >Pas productprijs aan</mat-checkbox
        >
        <price-line-input
          *ngIf="productToUsePlacementLine.get(product.id)"
          [priceLine]="productToPlacementLine.get(product.id)"
          (output)="placementLineChanged()"
        ></price-line-input>
      </div>
      <div
        *ngIf="
          isCustomWindowSticker(product) &&
          invoiceType === 'PlacementInvoice' &&
          customProductPrice.get(product.id) != null
        "
      >
        <div class="d-flex">
          <div class="first-form-field custom-price-label">
            <div class="price-label">
              Productieprijs
            </div>
            <mat-form-field appearance="outline">
              <mat-icon matPrefix>euro_symbol</mat-icon>
              <input
                [(ngModel)]="customProductPrice.get(product.id).productionPrice"
                (ngModelChange)="customPriceChange()"
                type="number"
                matInput
              />
            </mat-form-field>
          </div>

          <div class="form-field-no-flex custom-price-label">
            <div class="price-label">
              Plaatsingsprijs
            </div>
            <mat-form-field appearance="outline">
              <mat-icon matPrefix>euro_symbol</mat-icon>
              <input
                [(ngModel)]="customProductPrice.get(product.id).placementPrice"
                (ngModelChange)="customPriceChange()"
                type="number"
                matInput
              />
            </mat-form-field>
          </div>

          <div class="custom-price-label">
            <div class="price-label">
              Som
            </div>
            <mat-form-field appearance="outline">
              <mat-icon matPrefix>euro_symbol</mat-icon>
              <input
                matInput
                [disabled]="true"
                [value]="
                  customProductPrice.get(product.id)?.productionPrice
                    | sum: customProductPrice.get(product.id)?.placementPrice
                    | asFormatDecimal: true:2
                "
              />
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="title">
        Prijslijnen
      </div>
      <price-line-picker
        [inputList]="productToPriceLines.get(product.id)"
        [inputProduct]="product"
        (output)="combinePrices($event, product.id, product.type)"
      ></price-line-picker>
    </div>
    <div *ngIf="isBoard(product)">
      <board-placement-price
        [inputList]="productToPriceLines.get(product.id)"
        [inputBoard]="product"
        [subProject]="inputProject"
        [boardPartAdded]="boardPartAdded"
        [companyFactor]="companyFactor"
        [isRetailer]="inputInvoice.company.isRetailer"
        (output)="combinePrices($event, product.id, product.type)"
      ></board-placement-price>
    </div>
    <div *ngIf="isOtherProduct(product)">
      <div class="d-flex">
        <div class="first-form-field custom-price-label">
          <div class="price-label">
            Productieprijs
          </div>
          <mat-form-field appearance="outline">
            <mat-icon matPrefix>euro_symbol</mat-icon>
            <input
              [(ngModel)]="customProductPrice.get(product.id).productionPrice"
              (ngModelChange)="customPriceChange()"
              type="number"
              matInput
            />
          </mat-form-field>
        </div>

        <div class="form-field-no-flex custom-price-label">
          <div class="price-label">
            Plaatsingsprijs
          </div>
          <mat-form-field appearance="outline">
            <mat-icon matPrefix>euro_symbol</mat-icon>
            <input
              [(ngModel)]="customProductPrice.get(product.id).placementPrice"
              (ngModelChange)="customPriceChange()"
              type="number"
              matInput
            />
          </mat-form-field>
        </div>

        <div class="custom-price-label">
          <div class="price-label">
            Som
          </div>
          <mat-form-field appearance="outline">
            <mat-icon matPrefix>euro_symbol</mat-icon>
            <input
              matInput
              [disabled]="true"
              [value]="
                customProductPrice.get(product.id)?.productionPrice
                  | sum: customProductPrice.get(product.id)?.placementPrice
                  | asFormatDecimal: true:2
              "
            />
          </mat-form-field>
        </div>
      </div>
      <div class="title">
        Prijslijnen
      </div>
      <price-line-picker
        [inputList]="productToPriceLines.get(product.id)"
        [inputProduct]="product"
        (output)="combinePrices($event, product.id, product.type)"
      ></price-line-picker>
    </div>
  </div>
</div>
